import React from 'react';
import normalize from 'components/Dashboard/utilities/normalizeString';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
const SortFilter = (props) => {
  const { filter, selectOption, notIncludeName, setExpanded } = props;
  const { options, optionSelected, collapseOnSelect } = filter;
  return (
    <>
      {!notIncludeName && <h3>Sort by</h3>}
      <div className=''>
        {options.map((option, index) => {
          const { name, labelClassName } = option;
          const nameToUse = name === 'Recently published' && !getUrlParam('search') ? 'Opening date' : name;
          return (
            <div key={`option-filter${index}`} className='mb-3'>
              <div className={`radio-button`}>
                <input
                  id={normalize(name)}
                  onChange={() => {
                    let newValue = name;
                    selectOption({ filter, newValue });
                    if (collapseOnSelect && setExpanded) {
                      setExpanded(false);
                    }
                  }}
                  type={`radio`}
                  checked={optionSelected === name}
                />
                <label htmlFor={normalize(name)} className={`${labelClassName ? labelClassName : ''}`}>
                  {nameToUse}
                </label>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
export default SortFilter;
